import { calendarActions } from 'containers/Pages/CalendarUI';
import { takeLatest, put, call, select } from 'redux-saga/effects';
import { setLoading, showSnackbar } from 'reducers/ui';
import { errorHandler } from 'utils/errorMessages';
import API from 'services/api';
import { getTimezone } from 'reducers/utils';

export function* fetchCalendarTaskEvents({ payload }) {
  // rename to task events
  const { startDate, endDate } = payload;
  try {
    const tz = yield select(state => getTimezone(state));
    yield put(setLoading(true));
    const { data } = yield call(API.fetchTaskDashboardItems, {
      fromDate: startDate,
      toDate: endDate,
      timezone: tz, // not providing task type will give all category level tasks such as cleaning and maintenance
    });

    if (data.data) {
      yield put(
        calendarActions.setCalendarEvents({
          list: data.data?.dashboardItems,
          totalEntries: data.data?.dashboardItems.length,
          taskType: 'tasks',
          fromDate: data.data.fromDate,
          toDate: data.data.toDate,
        }),
      );
    }
    yield put(setLoading(false));
  } catch (err) {
    yield put(setLoading(false));
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
}
export function* fetchPatrolCalendarEvents({ payload }) {
  const { startDate, endDate } = payload;
  try {
    const tz = yield select(state => getTimezone(state));
    yield put(setLoading(true));
    const { data } = yield call(API.fetchPatrolDashboardItems, {
      fromDate: startDate,
      toDate: endDate,
      timezone: tz,
      // patrolType: [
      //   TASK_TYPE.PATROL_MULTISITE.id,
      //   TASK_TYPE.PATROL_SINGLE_SITE.id,
      // ],
    });

    if (data.data) {
      yield put(
        calendarActions.setCalendarEvents({
          list: data.data?.dashboardItems,
          totalEntries: data.data?.dashboardItems.length,
          taskType: 'patrols',
          fromDate: data.data.fromDate,
          toDate: data.data.toDate,
        }),
      );
    }
    yield put(setLoading(false));
  } catch (err) {
    yield put(setLoading(false));
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
}
//NOTE: This is needed if we want to show the type level as opposed to category level
// send taskCategory or service type to get types
// export function* fetchWorkOrderCalendarEvents({ payload }) {
//   const { startDate, endDate } = payload;
//   try {
//     const tz = yield select(state => getTimezone(state));
//     yield put(setLoading(true));
//     const { data } = yield call(API.fetchTaskDashboardItems, {
//       fromDate: startDate,
//       toDate: endDate,
//       timezone: tz,
//       taskCategory: [TASK_TYPE.MAINTENANCE.id],
//     });

//     if (data.data) {
//       yield put(
//         calendarActions.setCalendarEvents({
//           list: data.data?.dashboardItems,
//           totalEntries: data.data?.dashboardItems.length,
//           taskType: 'workOrders',
//           fromDate: data.data.fromDate,
//           toDate: data.data.toDate,
//         }),
//       );
//     }
//     yield put(setLoading(false));
//   } catch (err) {
//     yield put(setLoading(false));
//     yield put(
//       showSnackbar({
//         typeOfSnackbar: 'error',
//         message: errorHandler(err),
//       }),
//     );
//   }
// }
export function* fetchTransportCalendarEvents({ payload }) {
  const { startDate, endDate } = payload;
  try {
    const tz = yield select(state => getTimezone(state));
    yield put(setLoading(true));
    const { data } = yield call(API.fetchTripDashboardItems, {
      fromDate: startDate,
      toDate: endDate,
      timezone: tz,
      // serviceType: [TASK_TYPE.TRANSPORT_STANDARD.id],
    });

    if (data.data) {
      yield put(
        calendarActions.setCalendarEvents({
          list: data.data?.dashboardItems,
          totalEntries: data.data?.dashboardItems.length,
          taskType: 'transport',
          fromDate: data.data.fromDate,
          toDate: data.data.toDate,
        }),
      );
    }
    yield put(setLoading(false));
  } catch (err) {
    yield put(setLoading(false));
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
}

export function* calendarSagas() {
  yield takeLatest(
    calendarActions.fetchCalendarTaskEvents,
    fetchCalendarTaskEvents,
  );
  yield takeLatest(
    calendarActions.fetchPatrolEvents,
    fetchPatrolCalendarEvents,
  );
  yield takeLatest(
    calendarActions.fetchTransportEvents,
    fetchTransportCalendarEvents,
  );
}
